import type { SVGProps } from "react";
export interface CalendarHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CalendarHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CalendarHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21 6.875a1.125 1.125 0 0 1 0 2.25H3a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M19.875 6c0-.996-.778-1.81-1.76-1.87a1.124 1.124 0 0 1-2.233-.005H8.118a1.125 1.125 0 0 1-2.235.005A1.874 1.874 0 0 0 4.125 6v12c0 1.036.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm-5.918 3.875c.936 0 1.746.48 2.29 1.102.546.626.901 1.484.873 2.408l.003.001c-.037 1.226-.76 2.166-1.421 2.852l-.277.28c-.49.48-.961.924-1.367 1.3l-.98.897a1.615 1.615 0 0 1-2.039.099l-.119-.099c-.35-.314-.944-.853-1.633-1.509l-.715-.688c-.718-.703-1.656-1.73-1.697-3.132l.001-.001a3.53 3.53 0 0 1 .874-2.408c.544-.623 1.354-1.102 2.29-1.102.866 0 1.5.306 1.959.687.457-.38 1.092-.687 1.958-.687m0 2.25c-.294 0-.46.102-.587.229a1.4 1.4 0 0 0-.201.26l-.157.295-.001.001q-.011.02-.024.041a1.1 1.1 0 0 1-.2.265q-.037.038-.075.07a1 1 0 0 1-.224.147 1.1 1.1 0 0 1-.38.103 1.1 1.1 0 0 1-.32-.015 1.1 1.1 0 0 1-.279-.088 1.1 1.1 0 0 1-.225-.146q-.039-.034-.075-.07a1.1 1.1 0 0 1-.17-.212l-.03-.054-.023-.04-.001-.002c-.098-.203-.201-.4-.358-.556-.127-.126-.293-.228-.587-.228-.148 0-.379.084-.595.331a1.3 1.3 0 0 0-.319.747l-.001.113v.003l.017.161c.074.38.373.813 1.004 1.43.705.69 1.372 1.305 1.852 1.743a74 74 0 0 0 1.854-1.743l.25-.254c.538-.567.76-.969.77-1.337v-.116a1.3 1.3 0 0 0-.32-.747c-.216-.247-.447-.331-.595-.331M22.125 18A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6a4.12 4.12 0 0 1 4.006-4.119 1.125 1.125 0 0 1 2.237-.006h7.764a1.125 1.125 0 0 1 2.235.006 4.12 4.12 0 0 1 4.008 4.12v12Z"
      />
    </svg>
  );
}
